import { render, staticRenderFns } from "./videoCourseList.vue?vue&type=template&id=527a52ec&"
import script from "./videoCourseList.vue?vue&type=script&lang=js&"
export * from "./videoCourseList.vue?vue&type=script&lang=js&"
import style0 from "./videoCourseList.vue?vue&type=style&index=0&id=527a52ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports